import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { flagsReports, deleteFlagsReports } from "../../common/api";
import { ShowToast } from "../../common/function";
import { Sentry, Spinner } from "react-activity";
import { format } from "date-fns";


export default function FlagsReports() {
  const [searchText, setSearchText] = useState("");
  const [contactData, setContactData] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setShow(false);
    setSelectedId("");
  };

  const handleShow = (id) => {
    setSelectedId(id);
    setShow(true);
  };

  const getFlagsReports = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const res = await flagsReports(token, {});
    console.log(res);
    if (res?.success) {
      setContactData(res.body);
      setLoading(false);
    } else {
      ShowToast(0, res.message);
    }
  };

  useEffect(() => {
    getFlagsReports();
  }, []);
  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd-MM-yyyy");
  };
  const handleDelete = async () => {
    const token = localStorage.getItem("token");
    setIsLoading(true);
    const res = await deleteFlagsReports(token, { flagsReportId: selectedId });
    setIsLoading(false);
    if (res.success) {
      ShowToast(1, "Flags report deleted successfully");
      getFlagsReports();
      handleClose();
    } else {
      ShowToast(0, res.message || "Failed to delete flags report");
    }
  };

  const columns = [
    {
      name: "Sr. No.",
      selector: (row, index) => index + 1,
      width: "100px",
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Reported By",
      minWidth: "220px",
      selector: (row) => row.userDetails?.full_name,
      sortable: true,
      cell: (row) => <div><strong>{row.userDetails?.full_name || "N/A"}</strong> <br /> {row.userDetails?.email}</div>,
    },
    {
        name: "Reported To",
        minWidth: "220px",
        selector: (row) => row.reportedUserDetails?.full_name,
        sortable: true,
        cell: (row) => <div><strong>{row.reportedUserDetails?.full_name || "N/A"}</strong> <br /> {row.reportedUserDetails?.email}</div>,
      },
    {
      name: "Date",
      minWidth: "150px",
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
      cell: (row) => <>{formatDate(row.createdAt) || "N/A"}</>,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link className="btndelete" onClick={() => handleShow(row._id)}>
            <Icon icon="tabler:trash" />
          </Link>
        </>
      ),
    },
  ];

  const filteredData = contactData.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(searchText.toLowerCase()) !== -1
  );

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="py-4">
              <h5>Flags Reports</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {loading ? (
                <Sentry
                  color="#2B5AAC"
                  size={30}
                  speed={1}
                  animating={true}
                  style={{ marginLeft: "45%" }}
                />
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  responsive
                  className="custom-table"
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Delete Modal */}
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={handleDelete}
            disabled={isLoading}
          >
            {isLoading ? (
              <Spinner animation="border" variant="success" size={15} />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
